export const AMOUNT_INPUT_NODE_TYPE = 'amount-input'

export const AmountInputNodeDimensions = {
  width: 364,
  height: 60,
}

export const SourceWalletNodeDefs = {
  id: 'source-wallet',
  type: 'source-wallet',
  width: 110,
  height: 65,
}

export const AssetNodeDefs = {
  id: 'asset',
  type: 'asset',
  width: 110,
  height: 65,
}

export const ConnectorNodeDefs = {
  id: 'connector',
  type: 'connector',
  width: 4,
  height: 4,
  leftHandleId: 'left',
  rightHandleId: 'right',
}

export const AmountInputNodeDefs = {
  id: 'amount-input',
  type: 'amount-input',
  width: 364,
  height: 60,
}

export const DestinationWalletNodeDefs = {
  id: 'destination-wallet',
  type: 'destination-wallet',
  width: 110,
  height: 82,
}
